module.exports = __webpack_public_path__ + "res/28-img_reward_m.e1b01b9dc2cdb47d89a17ee46c830cae.png";